<template>
	<div class="v5-pagination">
		<ul class="v5-pagination-content">
			<li class="v5-pagination-btn v5-pagination-first" @click="firstChange">首页</li>
			<li class="v5-pagination-btn" @click="prevChange">
				<span class="v5-left-arrow" :class="{'v5-forbidden':currentNum === 1}"></span>
			</li>
			<li v-for=" i in totalArray" :key="i" class="v5-pagination-btn" :class="{'v5-pagination-active':currentNum === i,'v5-hasbackground':currentNum === i && background}"
			    :style="{styles:currentNum == i}" @click="updatePageNum(i)">{{i}}</li>
			<li class="v5-pagination-btn" @click="nextChange">
				<span class="v5-right-arrow" :class="{'v5-forbidden':currentNum === totalPage}"></span>
			</li>
			<li class="v5-pagination-btn v5-pagination-last" @click="lastChange">尾页</li>

		</ul>
	</div>
</template>
<script>
	export default {
		name: 'v5-pagination',
		props: {
			totalPage: {
				type: Number,
				default: 5
			},
			currentPage: {
				type: Number,
				default: 1
			},
			pageCount: {
				type: Number,
				default: 5
			},
			background: Boolean
		},
		data() {
			return {
				newPageCount: this.pageCount, //对于用户传入的newPageCount > totalPage的情况做处理
				totalArray: [], //循环页码的列表数组
				currentNum: this.currentPage, //当前选择页码
				oddCount: false, //newPageCount是否为奇数
				halfCount: 0 //newPageCount的一半 用于后续计数
			};
		},
		methods: {
			updatePageNum(index) {
				this.currentNum = index;
			},
			handleChange(index) {
				let leftArray = [],
					rightArray = [],
					top;
				//左边界情况
				if (index <= this.halfCount) {
					for (let j = 1; j <= this.newPageCount && j <= this.totalPage; j++) {
						leftArray.push(j);
					}
					this.totalArray = leftArray;
					this.$emit('on-update', this.currentNum);
					return;
				}
				//右边界情况
				if (index > this.totalPage - this.halfCount) {
					for (let j = this.totalPage; j > this.totalPage - this.newPageCount && j <= this.totalPage; j--) {
						leftArray.push(j);
					}
					this.totalArray = leftArray.reverse();
					this.$emit('on-update', this.currentNum);
					return;
				}
				//页码数为奇数
				if (this.oddCount) {
					top = index + this.halfCount;
				} else {
					//页码为偶数
					top = index + this.halfCount - 1;
				}
				//左数组
				for (let i = index - 1; i >= index - this.halfCount; i--) {
					leftArray.push(i);
				}
				//右数组
				for (let i = index + 1; i <= top && i <= this.totalPage; i++) {
					rightArray.push(i);
				}
				//更新数组
				this.totalArray = leftArray.reverse().concat(index).concat(rightArray);
				this.$emit('on-update', this.currentNum);
			},
			firstChange() {
				this.currentNum = 1;
			},
			lastChange() {
				this.currentNum = this.totalPage;
			},
			prevChange() {
				if (this.currentNum === 1) {
					return;
				}
				this.currentNum -= 1;
			},
			nextChange() {
				if (this.currentNum === this.totalPage) {
					return;
				}
				this.currentNum += 1;
			}
		},
		watch: {
			currentNum: function (val) {
				this.handleChange(val);
			}
		},
		mounted() {
			//对于用户传入的newPageCount > totalPage的情况做处理
			if (this.newPageCount > this.totalPage) {
				this.newPageCount = this.totalPage;
			}
			this.newPageCount % 2 === 0 ? this.oddCount = false : this.oddCount = true;
			this.halfCount = Math.floor(this.newPageCount / 2);
			if (this.newPageCount > 0) {
				for (let i = 1; i <= this.newPageCount; i++) {
					this.totalArray.push(i);
				}
			}
		}
	};

</script>
<style lang="scss">
	@import "./style.scss";

</style>
